import { NotificationType, SchedulerNotificationData } from '@/api/apis/communication';
import { SchedulerNotification } from './SchedulerNotification';
import { CaseNotification } from './CaseNotification';

export const Notification = ({ notification }: { notification: NotificationType }) => {
  if (notification.category === 'Scheduler') {
    return <SchedulerNotification notification={notification as NotificationType<SchedulerNotificationData>} />;
  }
  return <CaseNotification notification={notification} />;
};
